export default __webpack_public_path__ + "static/media/product_banner.e0e6afd4.jpg";